// Polis, l'onglet Registre de la nouvelle interface (10 octobre 2026).
// Les textes accordés au nombre ont deux formes, « singulier | pluriel » :
// l'écran choisit la forme comme la langue l'accorde (1,7 siège, 2,3 sièges).
export default {
  chargement: 'Chargement…',
  fermer: 'Fermer',
  pct: '{n} %',
  joint: '{a}, {b}',
  erreur: {
    lecture: 'Lecture impossible.',
    preuve: 'La preuve de cette projection est indisponible pour le moment.',
    contenu: 'Ce qui a été scellé pour cette projection est indisponible pour le moment.',
  },
  bref: {
    aria: 'Le registre en bref',
    scellees: 'projection scellée | projections scellées',
    dontEssais: 'dont {n} essai | dont {n} essais',
    confrontees: 'confrontée au résultat | confrontées au résultat',
    scrutinLe: 'le scrutin a lieu le {jour}',
    scrutinAujourdhui: 'le scrutin a lieu aujourd’hui',
    attenteResultat: 'en attente du résultat',
    fideliteSieges: 'des sièges placés comme les sondages par les jumeaux, sans les lire',
    fideliteVoix: 'des voix placées comme les sondages par les jumeaux, sans les lire',
    vagueDu: 'vague du {jour}',
    sondagesSieges: 'siège d’écart par liste dans les sondages, deux semaines avant le vote | sièges d’écart par liste dans les sondages, deux semaines avant le vote',
    sondagesPoints: 'point d’écart par candidat dans les sondages, deux semaines avant le vote | points d’écart par candidat dans les sondages, deux semaines avant le vote',
    surElections: 'mesuré sur {n} élection passée | mesuré sur {n} élections passées',
  },
  scellees: {
    titre: 'Les projections scellées',
    sousTitre: 'personne ne peut les retoucher : l’empreinte est relue à chaque ouverture · heure de Paris',
    vide: 'Aucune projection scellée pour cette élection. Une projection scellée avant le vote s’inscrit ici, avec sa preuve.',
    quand: '{jour}, {heure}',
    // Sa vague et sa sorte (21 octobre 2026) : scellée seule à la lecture de la vague, à la main pour de bon, ou en essai.
    vague: {
      automatique: 'Vague du {jour}, scellée automatiquement',
      definitive: 'Vague du {jour}, projection définitive',
      essai: 'Vague du {jour}, essai',
    },
    // La même, quand le contenu ne date pas sa vague.
    seule: {
      automatique: 'Scellée automatiquement',
      definitive: 'Projection définitive',
      essai: 'Essai',
    },
    fourchette: '{bas} ~ {haut}',
    lectureOrion: 'Projection d’Orion',
    lectureJumeaux: 'Jumeaux seuls',
    intacte: 'empreinte intacte',
    alteree: 'empreinte altérée',
    temoins: '{n} témoin sur {sur} | {n} témoins sur {sur}',
    contenu: 'Télécharger ce qui a été scellé',
    contenuAria: 'Télécharger ce qui a été scellé le {quand}',
    preuve: 'Télécharger la preuve',
    preuveAria: 'Télécharger la preuve de la projection du {quand}',
  },
  // Comment vérifier une projection scellée sans Orion (21 octobre 2026) : jamais comment Orion la calcule.
  verifier: {
    titre: 'Comment vérifier, sans Orion',
    telecharger: 'Téléchargez ce qui a été scellé et sa preuve, dans le même dossier.',
    deposer: 'Sur {site}, déposez la preuve, puis le contenu ; ou, en ligne de commande, dans ce dossier : {commande}',
    commande: 'ots verify projection-xxxx.json.ots',
    bloc: 'La réponse donne le bloc Bitcoin et sa date. Tant que l’ancrage n’est pas fait, quelques heures après le scellement, la preuve est « en attente » : {commande} récupère la preuve complète.',
    upgrade: 'ots upgrade projection-xxxx.json.ots',
    virgule: 'Changer une seule virgule du contenu change son empreinte : la vérification échoue.',
  },
  vagues: {
    titre: 'Chaque vague, face aux sondages de sa semaine',
    sousTitreSieges: 'la part des sièges placés comme la moyenne des sondages ; à droite, l’écart moyen par liste',
    sousTitreVoix: 'la part des voix placées comme la moyenne des sondages ; à droite, l’écart moyen par candidat',
    legende: 'Les trois lectures',
    jumeaux: 'Jumeaux seuls',
    entourage: 'Leur entourage',
    calibree: 'La projection (calée sur les sondages)',
    libelle: '{jour} · {libelle}',
    ecartSieges: '{n} siège | {n} sièges',
    ecartPoints: '{n} point | {n} points',
  },
  sondages: {
    titre: 'Ce que valent les sondages',
    surElections: 'mesuré sur {n} élection passée | mesuré sur {n} élections passées',
    ecartSieges: 'siège d’écart par liste, deux semaines avant le vote | sièges d’écart par liste, deux semaines avant le vote',
    ecartPoints: 'point d’écart par candidat, deux semaines avant le vote | points d’écart par candidat, deux semaines avant le vote',
    blocValeur: '± {n}',
    blocSieges: 'siège sur le premier bloc, d’une élection à l’autre | sièges sur le premier bloc, d’une élection à l’autre',
    blocPoints: 'point sur le premier bloc, d’une élection à l’autre | points sur le premier bloc, d’une élection à l’autre',
    seuilValeur: '{tombees} / {listes}',
    seuil: 'listes données entre 3 et 6 sièges sont tombées à zéro',
    sortiesSieges: 'siège d’écart par liste pour les sorties des urnes | sièges d’écart par liste pour les sorties des urnes',
    sortiesPoints: 'point d’écart par candidat pour les sorties des urnes | points d’écart par candidat pour les sorties des urnes',
    sortiesSur: 'sur {n} élection | sur {n} élections',
  },
  banc: {
    titre: 'Le banc d’opinion',
    sousTitre: 'les jumeaux face à une enquête publiée, question par question',
    evolution: '{a} → {b}',
    ecartUne: 'point d’écart par réponse, passe {passe} | points d’écart par réponse, passe {passe}',
    ecartDeux: 'point d’écart par réponse, entre la passe {a} et la passe {b} | points d’écart par réponse, entre la passe {a} et la passe {b}',
    sens: 'point d’erreur sur le sens de la réponse | points d’erreur sur le sens de la réponse',
    passe: 'Passe {v}',
    details: '{jour} · {territoire} · {n} question | {jour} · {territoire} · {n} questions',
    ligneEcart: 'écart par réponse',
    ligneSens: 'erreur sur le sens',
    pts: '{n} pt | {n} pts',
    juifs: 'Juifs {n}',
    arabes: 'Arabes {n}',
  },
  participation: {
    titre: 'La participation passée',
    sousTitre: 'moyenne et écart d’une élection à l’autre',
    valeur: '{moyenne} % ± {ecart}',
  },
}
